import React from 'react'
import { compose, pure } from 'recompose'
import { translate } from 'react-i18next'
import routes from '../root/routes'
import PageWrapper from '../../components/pageWrapper/pageWrapperComponent'
import StemIcon from '../../assets/icons/iconStem.svg'
import PropTypes from 'prop-types'
import CareerContentDetail from '../../components/careerContentDetail/careerContentDetailComponent'

export class StemCareersRoute extends React.Component {
  render () {
    const { t } = this.props
    return (
      <PageWrapper
        heroImage={require('../../assets/images/hero_careers_stem.jpg')}
        heroAlt={t('hero:stemCareers')}
      >
        <CareerContentDetail
          endorsement={t('stem:title')}
          icon={<StemIcon />}
          endorsementRoute={routes.stem}
          description={t('stem:careerDescription')}
          careers={t('stem:careers', { returnObjects: true })}
        />
      </PageWrapper>
    )
  }
}

StemCareersRoute.propTypes = {
  t: PropTypes.func
}

export default compose(pure, translate())(StemCareersRoute)



// WEBPACK FOOTER //
// ./src/routes/stemCareers/stemCareersRoute.js